import { OrganizationCreateType, OrganizationEditType } from '@/shared/types'
import { getDateFormat } from '@/shared/utils'
import { DATE_FORMAT } from '@/shared/constants'

export class OrganizationDataMapper {
  static mapOrganizationCreationData = (
    organization: OrganizationCreateType
  ): FormData => {
    const {
      name,
      address,
      inn,
      phone,
      site,
      isTest,
      logo,
      modules,
      packageCount,
      blockAt,
      tariffId,
      subscriptionType,
      useCustomTariff,
      customTariffData,
      dealDate,
    } = organization

    const formData = new FormData()

    formData.append('name', name)
    formData.append('address', address)
    formData.append('is_test', String(isTest))

    if (packageCount) {
      formData.append('package_count', String(packageCount))
    }

    if (blockAt) {
      formData.append(
        'block_at',
        getDateFormat(new Date(blockAt), DATE_FORMAT.dmyDot)
      )
    }

    if (inn) {
      formData.append('inn', inn)
    }

    if (phone) {
      formData.append('phone', phone)
    }

    if (site) {
      formData.append('site', site)
    }

    if (logo) {
      formData.append('logo', logo)
    }

    if (modules) {
      modules.forEach((module) => formData.append('modules[]', module))
    }

    if (tariffId && tariffId != -1) {
      formData.append('tariff_id', tariffId.toString())
    }

    if (subscriptionType) {
      formData.append('subscription_type', subscriptionType ?? '')
    }

    formData.append('use_custom_tariff', useCustomTariff.toString())

    if (useCustomTariff) {
      for (const key in customTariffData) {
        formData.append(`custom_tariff[${key}]`, customTariffData[key] ?? 0)
      }
    }

    if (dealDate) {
      formData.append('deal_date', dealDate)
    }

    return formData
  }

  static mapOrganizationEditionData = (
    organization: OrganizationEditType
  ): FormData => {
    const {
      name,
      address,
      logo,
      inn,
      isTest,
      phone,
      site,
      isBlocked,
      status,
      partner,
      blockDate,
      packageCount,
      modules,
      tariffId,
      subscriptionType,
      useCustomTariff,
      customTariffData,
      dealDate,
      lastPaymentDate,
      telegramEnabled,
      telegramNotificationsEnabled,
      qrCodesEnabled,
    } = organization

    const formData = new FormData()

    if (logo.length && logo[0].raw) {
      formData.append('logo', logo[0].raw)
    }

    formData.append('name', name)
    formData.append('address', address)
    formData.append('inn', inn ?? '')
    formData.append('is_test', String(isTest))
    formData.append('phone', phone ?? '')
    formData.append('site', site ?? '')
    formData.append('partner', partner ?? '')
    formData.append('status', status ?? '')
    formData.append('is_blocked', isBlocked.toString())
    formData.append(
      'block_at',
      getDateFormat(new Date(blockDate), DATE_FORMAT.dmyDot)
    )
    formData.append('package_count', packageCount.toString())
    modules.forEach((module) => formData.append('modules[]', module))
    if (modules.length === 0) {
      formData.append('modules[]', '')
    }

    if (tariffId && tariffId != -1) {
      formData.append('tariff_id', tariffId.toString())
    }

    formData.append('subscription_type', subscriptionType ?? '')
    formData.append('use_custom_tariff', useCustomTariff.toString())

    if (useCustomTariff) {
      for (const key in customTariffData) {
        formData.append(`custom_tariff[${key}]`, customTariffData[key] ?? 0)
      }
    }

    if (dealDate) {
      formData.append('deal_date', dealDate)
    }

    if (lastPaymentDate) {
      formData.append('last_payment_date', lastPaymentDate)
    }

    formData.append('telegram_enabled', (telegramEnabled ? 1 : 0).toString())
    formData.append(
      'telegram_notifications_enabled',
      (telegramNotificationsEnabled ? 1 : 0).toString()
    )
    formData.append('qr_codes_enabled', qrCodesEnabled ? '1' : '0')

    return formData
  }
}
